export default __webpack_public_path__ + "static/media/tktIcon.bb24db4c.svg";